var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgT2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2001_181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 6.39708C18 2.87579 14.9562 0.0110474 11.2148 0.0110474C8.5243 0.0110474 6.19453 1.49261 5.09804 3.63441C3.69056 3.97406 2.41798 4.74429 1.50015 5.81578C0.532758 6.94518 0 8.36765 0 9.82108C0 11.1885 0.447328 12.4809 1.2966 13.5761L0.0586406 16.9301L3.99452 15.6433C4.87301 16.0175 5.8107 16.2071 6.78516 16.2071C9.40071 16.2071 11.7775 14.792 12.904 12.5837C13.2799 12.4929 13.6477 12.3717 14.0055 12.2192L17.9414 13.5061L16.7034 10.1521C17.5527 9.05684 18 7.76442 18 6.39708ZM6.78516 15.2145C5.89834 15.2145 5.04805 15.0288 4.25781 14.6626L4.06005 14.571L1.76948 15.3199L2.48112 13.3919L2.30017 13.178C1.48535 12.2152 1.05469 11.0543 1.05469 9.82108C1.05469 8.57574 1.49266 7.40617 2.32126 6.43877C2.93653 5.72046 3.74024 5.16265 4.63936 4.8195C4.5026 5.32426 4.42969 5.85278 4.42969 6.39704C4.42969 9.91833 7.47348 12.7831 11.2148 12.7831C11.3374 12.7831 11.4594 12.78 11.5807 12.7741C10.5332 14.2796 8.73833 15.2145 6.78516 15.2145ZM13.94 11.147L13.7422 11.2386C12.9519 11.6048 12.1016 11.7905 11.2148 11.7905C8.05504 11.7905 5.48438 9.37105 5.48438 6.39711C5.48438 3.42317 8.05504 1.00373 11.2148 1.00373C14.3747 1.00373 16.9453 3.42317 16.9453 6.39711C16.9453 7.63034 16.5146 8.79118 15.6998 9.75408L15.5189 9.96793L16.2305 11.8959L13.94 11.147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43263 3.41388L7.56717 8.02376L8.55277 8.37708L8.85505 7.63015H10.9182L11.2172 8.37566L12.2039 8.02519L10.3546 3.41312L9.43263 3.41388ZM9.25671 6.6375L9.89135 5.06922L10.5202 6.6375H9.25671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3914 5.98349H14.446V8.36584H13.3914V5.98349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3914 3.9982H14.446V4.99085H13.3914V3.9982Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2001_181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16.9412,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT2);
export default __webpack_public_path__ + "static/media/t2.fab571376cb0e2cc109c96ea274bc48c.svg";
export { ForwardRef as ReactComponent };